(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  (function () {
    var path = location.pathname.replace(/\/+$/, '');
    if (!path.endsWith('/search')) return;
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var params = new URLSearchParams(location.search);
    var terms = (params.get('q') || '').trim();
    if (terms.length < 2) return;

    var emptyEl = document.getElementById('junis-search-empty');
    var locId = window.__junisCompanyLocationId;
    var base =
      '/apps/wishtrade/search?q=' +
      encodeURIComponent(terms) +
      (locId ? '&companyLocationId=' + encodeURIComponent(locId) : '');
    var PAGE_SIZE = 20;

    var seen = new Set(
      Array.prototype.slice.call(grid.querySelectorAll('li[data-product-id]')).map(function (li) {
        return li.getAttribute('data-product-id');
      })
    );
    var added = 0;

    function mergeHtml(html) {
      var trimmed = (html || '').trim();
      if (!trimmed) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = trimmed;
      Array.prototype.slice.call(tmp.querySelectorAll('li[data-product-id]')).forEach(function (li) {
        var id = li.getAttribute('data-product-id');
        if (id && !seen.has(id)) {
          seen.add(id);
          grid.appendChild(li);
          added += 1;
        }
      });
      if (added > 0 && emptyEl) emptyEl.hidden = true;
    }

    function fetchPage(p) {
      return (window.junisFetch || fetch)(base + '&page=' + p, { headers: { Accept: 'text/html' }, credentials: 'same-origin', junisTimeout: 10000, junisRetries: 1 })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }

    // page 0 응답에서 total 을 읽고, 20개 초과면 나머지 페이지(1..ceil(total/20)-1)를 병렬 fetch.
    fetchPage(0)
      .then(function (html0) {
        var total = 0;
        var trimmed = (html0 || '').trim();
        if (trimmed) {
          var tmp0 = document.createElement('div');
          tmp0.innerHTML = trimmed;
          var totalEl = tmp0.querySelector('[data-junis-total]');
          total = totalEl ? parseInt(totalEl.getAttribute('data-junis-total'), 10) || 0 : 0;
        }
        mergeHtml(html0);

        var pages = Math.ceil(total / PAGE_SIZE);
        if (pages <= 1) return [];
        var rest = [];
        for (var p = 1; p < pages; p++) rest.push(fetchPage(p));
        return Promise.all(rest);
      })
      .then(function (htmls) {
        (htmls || []).forEach(function (h) {
          mergeHtml(h);
        });
        // items 카운트 갱신 — 서버는 상품명 후필터(matched_count)만 셈 → App Proxy 추가분 포함한
        //   그리드 총 li 개수로 교체(숫자만 치환, 'items' 라벨 i18n 유지).
        var countEl = document.querySelector('.products-count-wrapper span, [data-testid="products-count"] span');
        if (countEl) {
          var totalCards = grid.querySelectorAll('li[data-product-id]').length;
          countEl.textContent = countEl.textContent.replace(/[\d,]+/, totalCards);
        }
        if (added > 0) {
          document.dispatchEvent(new CustomEvent('junis:cards-added', { detail: { count: added } }));
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
